import { createContext, useState, useRef } from "react";

import inboxService from "../services/inbox.service";
import MessagesService from "../services/messages.service";
import moment from "moment";
import { io } from "socket.io-client";
import UIkit from "uikit";

const NO_SELECTION = -1;

const socket = io("https://ruebarue-socket-proxy.herokuapp.com", {
  transports: ["websocket"],
  reconnection: true,
});

const defaultRecipient = {
  first_name: "",
  last_name: "",
  email: "",
  schedule: [
    {
      weekday: 2,
      start_time: "2001-01-02 09:00:00",
      end_time: "2001-01-02 17:00:00",
    },
    {
      weekday: 3,
      start_time: "2001-01-03 09:00:00",
      end_time: "2001-01-03 17:00:00",
    },
    {
      weekday: 4,
      start_time: "2001-01-04 09:00:00",
      end_time: "2001-01-04 17:00:00",
    },
    {
      weekday: 5,
      start_time: "2001-01-05 09:00:00",
      end_time: "2001-01-05 17:00:00",
    },
    {
      weekday: 6,
      start_time: "2001-01-06 09:00:00",
      end_time: "2001-01-06 17:00:00",
    },
  ],
};

export const InboxContext = createContext();
export const InboxProvider = ({ children }) => {
  const [loading, setLoading] = useState(false);
  const [isSendingFlag, setIsSending] = useState(false);
  const [isNew, setIsNew] = useState(false);
  const [settings, setSettings] = useState(null);
  const [inbox, setInbox] = useState(null);
  const [threadCnt, setThreadCnt] = useState(0);
  const [reservation, setReservation] = useState(null);
  const [filters, setFilters] = useState({});
  const [selectedThreadId, setSelectedThreadId] = useState(0);
  const [threadDetail, setThreadDetail] = useState({});
  const [nextThread, setNextThread] = useState(null);
  // const [currentIndexOnPage, setCurrentIndexOnPage] = useState(-1);
  const [messageOffset, setMessageOffset] = useState(0);
  const messageOffsetRef = useRef(0);

  const [recipient, setRecipient] = useState(
    JSON.parse(JSON.stringify(defaultRecipient)),
  );
  const [deletedRecipient, setDeletedRecipient] = useState(null);
  const [recipientPending, setRecipientPending] = useState(false);
  const [invitePending, setInvitePending] = useState(false);

  const [legacy, setLegacy] = useState(false);

  let contextInbox = {
    loading,
    isSendingFlag,
    isNew,
    setIsNew,
    inbox,
    settings,
    setInbox,
    reservation,
    setReservation,
    filters,
    setFilters,
    selectedThreadId,
    setSelectedThreadId,
    setThreadDetail,
    threadDetail,
    socket,
    threadCnt,
    setThreadCnt,

    recipient,
    setRecipient,
    deletedRecipient,
    setDeletedRecipient,
    recipientPending,
    setRecipientPending,
    invitePending,
    setInvitePending,

    nextThread,

    legacy,
    setLegacy,

    // currentIndexOnPage,
    // setCurrentIndexOnPage,

    get: async () => {
      setLoading(true);
      let resp = await inboxService.get();
      setSettings(resp.data);
      setLoading(false);
    },
    initRecipient: () => {
      setRecipient(defaultRecipient);
    },
    createRecipient: async (recipient) => {
      setRecipientPending(true);
      try {
        const resp = await inboxService.createRecipient(recipient);
        setRecipientPending(false);
        setSettings({ ...settings, recipients: resp.data });
        setRecipient(JSON.parse(JSON.stringify(defaultRecipient)));
        return resp.data;
      } catch (err) {
        console.warn(err);
        setRecipientPending(false);
        throw err;
      }
    },
    updateRecipient: async (recipient) => {
      setRecipientPending(true);
      try {
        const resp = await inboxService.updateRecipient(recipient);
        setSettings({ ...settings, recipients: resp.data });
        setRecipientPending(false);
        setRecipient(JSON.parse(JSON.stringify(defaultRecipient)));
        return resp.data;
      } catch (err) {
        console.warn(err);
        setRecipientPending(false);
        throw err;
      }
    },
    deleteRecipient: async (recipient) => {
      setRecipientPending(true);
      inboxService
        .deleteRecipient(recipient.recipient_id)
        .then((resp) => {
          setSettings({ ...settings, recipients: resp.data });
          setRecipientPending(false);
          setRecipient(JSON.parse(JSON.stringify(defaultRecipient)));
        })
        .catch((err) => {
          console.warn(err);
          setRecipientPending(false);
        });
    },
    undeleteRecipient: async (recipient) => {
      setRecipientPending(true);
      inboxService
        .undeleteRecipient(recipient.recipient_id)
        .then((resp) => {
          setSettings({ ...settings, recipients: resp.data });
          setRecipientPending(false);
          setRecipient(JSON.parse(JSON.stringify(defaultRecipient)));
        })
        .catch((err) => {
          console.warn(err);
          setRecipientPending(false);
          UIkit.notification(
            "Sorry, this user could not be reinstated, please contact RueBaRue support.",
            "error",
          );
        });
    },
    inviteRecipient: async (recipient) => {
      setInvitePending(true);
      inboxService
        .inviteRecipient(recipient.recipient_id)
        .then(async (resp) => {
          await setSettings({ ...settings, recipients: resp.data });
          setInvitePending(false);
        })
        .catch((err) => {
          console.warn(err);
          setInvitePending(false);
        });
    },
    refresh: async (
      pageNo,
      filter,
      pageSize,
      stopLoading = false,
      nextIndex = null,
    ) => {
      console.log("Stop Loading", stopLoading);
      if (!stopLoading) {
        setLoading(true);
      }
      try {
        // TODO: update inbox page & filter
        const response = await inboxService.getInboxes(
          pageNo,
          filter,
          pageSize,
        );
        const { error, page, count } = response.data;

        if (error) {
          throw error;
        }

        if (nextIndex !== null) {
          if (nextIndex >= page.length) {
            nextIndex = page.length - 1;
          }

          if (nextIndex >= 0) {
            setNextThread(page[nextIndex].id);
          }
        }

        setInbox(page);
        setThreadCnt(count);
      } catch (err) {
        console.warn(err);
      }
      setLoading(false);
    },
    personalInbox: async (
      personalInboxId,
      pageNo,
      filter,
      pageSize,
      stopLoading = false,
      nextIndex = null,
    ) => {
      if (legacy) {
        return contextInbox.refresh(
          pageNo,
          filter,
          pageSize,
          stopLoading,
          nextIndex,
        );
      }

      if (!stopLoading) {
        setLoading(true);
      }
      try {
        // TODO: update inbox page & filter
        const response = await inboxService.getPersonalInbox(
          personalInboxId,
          pageNo,
          filter,
          pageSize,
        );
        const { error, page, count } = response.data;

        if (error) {
          throw error;
        }

        if (nextIndex !== null) {
          if (nextIndex >= page.length) {
            nextIndex = page.length - 1;
          }

          if (nextIndex >= 0) {
            setNextThread(page[nextIndex].id);
          }
        }

        setInbox(page);
        setThreadCnt(count);
      } catch (err) {
        console.warn(err);
      }
      setLoading(false);
    },

    selectThread: async (threadId) => {
      setLoading(true);
      try {
        // Fetch the first page of messages
        const response = await inboxService.getInboxThread(threadId);
        const { error, thread } = response.data;
        if (inbox) {
          let updatedInbox = inbox.map((item) => {
            if (
              item.id.toString() === thread.id.toString() &&
              item.meta_values?.indexOf("unread") >= 0
            ) {
              return {
                ...item,
                meta_values: item.meta_values?.replace("unread", "read"),
              };
            }
            return item;
          });
          setInbox(updatedInbox);
        }
        setThreadDetail(thread);
        const initialOffset = thread.messages ? thread.messages.length : 0;
        setMessageOffset(initialOffset);
        messageOffsetRef.current = initialOffset;
      } catch (err) {
        console.log("error:", err);
        setLoading(false);
      }
      setSelectedThreadId(threadId);
      setNextThread(null);
      setLoading(false);
    },
    selectPaginatedThread: async (threadId, index) => {
      setLoading(true);
      try {
        // Fetch the first page of messages
        const response = await inboxService.getPaginatedInboxThread(threadId, {
          offset: 0,
          limit: 30,
        });
        const { error, thread } = response.data;
        if (inbox) {
          let updatedInbox = inbox.map((item) => {
            if (
              item.id.toString() === thread.id.toString() &&
              item.meta_values?.indexOf("unread") >= 0
            ) {
              return {
                ...item,
                meta_values: item.meta_values?.replace("unread", "read"),
              };
            }
            return item;
          });
          setInbox(updatedInbox);
        }
        setThreadDetail(thread);
        const initialOffset = thread.messages ? thread.messages.length : 0;
        setMessageOffset(initialOffset);
        messageOffsetRef.current = initialOffset;
      } catch (err) {
        console.log("error:", err);
        setLoading(false);
      }
      setSelectedThreadId(threadId);
      setNextThread(null);
      setLoading(false);
    },
    selectPersonalPaginatedThread: async (threadId, personalInboxId, index) => {
      if (legacy) {
        return contextInbox.selectPaginatedThread(threadId, index);
      }

      setLoading(true);
      try {
        // Fetch the first page of messages
        const response = await inboxService.getPersonalPaginatedInboxThread(
          threadId,
          personalInboxId,
          {
            offset: 0,
            limit: 30,
          },
        );
        const { error, thread } = response.data;
        if (inbox) {
          let updatedInbox = inbox.map((item) => {
            if (
              item.id.toString() === thread.id.toString() &&
              item.meta_values?.indexOf("unread") >= 0
            ) {
              console.log(item);
              return {
                ...item,
                meta_values: item.meta_values.filter((v) => v !== "unread"),
              };
            }
            return item;
          });
          setInbox(updatedInbox);
        }
        setThreadDetail(thread);
        const initialOffset = thread.messages ? thread.messages.length : 0;
        setMessageOffset(initialOffset);
        messageOffsetRef.current = initialOffset;
      } catch (err) {
        console.log("error:", err);
        setLoading(false);
      }
      setSelectedThreadId(threadId);
      setNextThread(null);
      setLoading(false);
    },
    loadMoreMessages: async (threadId, offset, limit = 30) => {
      // Fetch older messages for infinite scroll
      try {
        const response = await inboxService.getPaginatedInboxThread(threadId, {
          offset,
          limit,
        });
        const { error, thread } = response.data;
        if (error) return 0;

        const apiCount = (thread.messages || []).length;
        setThreadDetail((prev) => {
          if (!prev || !prev.messages) return prev;
          // Remove duplicates (in case of overlap)
          const existingIds = new Set(prev.messages.map((m) => m.message_id));
          const newMessages = (thread.messages || []).filter(
            (m) => !existingIds.has(m.message_id),
          );
          return {
            ...prev,
            messages: [...newMessages, ...prev.messages],
          };
        });
        setMessageOffset((prev) => {
          const newOffset = prev + apiCount;
          messageOffsetRef.current = newOffset;
          return newOffset;
        });
        return apiCount;
      } catch (err) {
        console.log("error loading more messages:", err);
        return 0;
      }
    },
    loadMorePersonalMessages: async (
      threadId,
      personalInboxId,
      offset,
      limit = 30,
    ) => {
      if (legacy) {
        return contextInbox.loadMoreMessages(threadId, offset, limit);
      }

      // Fetch older messages for infinite scroll
      try {
        const response = await inboxService.getPersonalPaginatedInboxThread(
          threadId,
          personalInboxId,
          {
            offset,
            limit,
          },
        );
        const { error, thread } = response.data;
        if (error) return 0;

        const apiCount = (thread.messages || []).length;
        setThreadDetail((prev) => {
          if (!prev || !prev.messages) return prev;
          // Remove duplicates (in case of overlap)
          const existingIds = new Set(prev.messages.map((m) => m.message_id));
          const newMessages = (thread.messages || []).filter(
            (m) => !existingIds.has(m.message_id),
          );
          return {
            ...prev,
            messages: [...newMessages, ...prev.messages],
          };
        });
        setMessageOffset((prev) => {
          const newOffset = prev + apiCount;
          messageOffsetRef.current = newOffset;
          return newOffset;
        });
        return apiCount;
      } catch (err) {
        console.log("error loading more messages:", err);
        return 0;
      }
    },
    getThreadDetail: async (thread_id) => {
      try {
        const response = await inboxService.getInboxThread(thread_id);
        const { error, thread } = response.data;
        setThreadDetail(thread);
        return thread;
      } catch (err) {
        console.warn(err);
      }
    },
    getPaginatedThreadDetail: async (thread_id, offset = 0, limit = 30) => {
      try {
        const response = await inboxService.getPaginatedInboxThread(thread_id, {
          offset,
          limit,
        });
        const { error, thread } = response.data;
        if (error) return 0;

        setThreadDetail((prev) => {
          if (!prev || !prev.messages) return prev;
          // Remove duplicates (in case of overlap)
          const existingIds = new Set(prev.messages.map((m) => m.message_id));
          const newMessages = (thread.messages || []).filter(
            (m) => !existingIds.has(m.message_id),
          );

          const sortedMessages = [...newMessages, ...prev.messages]
            .sort((a, b) => {
              return (
                moment(a.created_at).valueOf() - moment(b.created_at).valueOf()
              );
            })
            .filter((m) => {
              return !!m.message_id;
            });

          return {
            ...prev,
            messages: sortedMessages,
          };
        });

        return thread;
      } catch (err) {
        console.warn(err);
      }
    },
    getPersonalPaginatedThreadDetail: async (
      thread_id,
      personal_inbox_id,
      offset = 0,
      limit = 30,
    ) => {
      if (legacy) {
        return contextInbox.getPaginatedThreadDetail(thread_id, offset, limit);
      }

      try {
        const response = await inboxService.getPersonalPaginatedInboxThread(
          thread_id,
          personal_inbox_id,
          {
            offset,
            limit,
          },
        );
        const { error, thread } = response.data;
        if (error) return 0;

        setThreadDetail((prev) => {
          if (!prev || !prev.messages) return prev;
          // Remove duplicates (in case of overlap)
          const existingIds = new Set(prev.messages.map((m) => m.message_id));
          const newMessages = (thread.messages || []).filter(
            (m) => !existingIds.has(m.message_id),
          );

          const sortedMessages = [...newMessages, ...prev.messages]
            .sort((a, b) => {
              return (
                moment(a.created_at).valueOf() - moment(b.created_at).valueOf()
              );
            })
            .filter((m) => {
              return !!m.message_id;
            });

          return {
            ...prev,
            messages: sortedMessages,
          };
        });

        return thread;
      } catch (err) {
        console.warn(err);
      }
    },
    setMeta: async (thread_id, data) => {
      let result = await inboxService.setMeta(thread_id, data);
      return result.data;
    },
    setPersonalMeta: async (thread_id, personal_inbox_id, token, set) => {
      if (legacy) {
        return contextInbox.setMeta(thread_id, {
          thread_id: thread_id,
          token: token,
          state: set,
        });
      }

      let result = await inboxService.setPersonalMeta(
        thread_id,
        personal_inbox_id,
        token,
        set,
      );
      return result.data;
    },
    togglePersonalMeta: async (thread_id, personal_inbox_id, token) => {
      if (legacy) {
        return contextInbox.setMeta(thread_id, {
          thread_id: thread_id,
          token: token,
        });
      }

      let result = await inboxService.togglePersonalMeta(
        thread_id,
        personal_inbox_id,
        token,
      );

      return result.data;
    },
    toggleInboxRestriction: async (personal_inbox_id, token) => {
      let result = await inboxService.toggleInboxRestriction(
        personal_inbox_id,
        token,
      );

      return result.data;
    },

    sendMessage: async (objMessage) => {
      setIsSending(true);
      const result = await MessagesService.sendMessage(objMessage);
      if (result.data) {
        setThreadDetail({ ...threadDetail, ...result.data });
      }
      setIsSending(false);
      return result.data;
    },
  };

  contextInbox.messageOffsetRef = messageOffsetRef;

  return (
    <InboxContext.Provider value={contextInbox}>
      {children}
    </InboxContext.Provider>
  );
};
